import { Injectable } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { TextHelper } from '../helpers/text.helper';

@Injectable()
export class CustomNotificationService{

  constructor(private readonly toastr: ToastrService) {}

  success(content: string| string[], options?: Partial<IndividualConfig>): ActiveToast<any> {
    return  this.toastr.success(this.getContentAsString(content), "", {timeOut: 4000, ...options});
  }
  info(content: string| string[], options?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.toastr.info(this.getContentAsString(content), "", {timeOut: 6000, ...options});
  }
  warning(content: string | string[], options?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.toastr.warning(this.getContentAsString(content), "", {timeOut: 10000, ...options});
  }
  error(content: string| string[], options?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.toastr.error(this.getContentAsString(content), "", {disableTimeOut: true, closeButton: true, ...options});
  }

  getContentAsString(content: string| string[]): string{
    if(!content) return "";
    if(content.length === 1) return TextHelper.sanitize(content[0]);
    if(Array.isArray(content)) return `<ul class='pl-3 m-0'>${content.reduce((prev,curr) => `${prev}<li>${TextHelper.sanitize(curr)}</li>`, "")}</ul>`;
         
    return TextHelper.sanitize(content);
  }
}